export default "__VITE_ASSET__BY$IZUQ1__"